import axios from 'axios';
import React, { useState } from 'react';
import { IoCloseSharp } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';
import { BASE_URL, USER_URL } from '../../constant/api';

function ProductApprovalModel({ selectedProduct, isModalOpen, closeModal, status }) {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleStatusUpdate = async () => {
        if (!selectedProduct || !status) return;
        setLoading(true); // Start loading
        try {
            const res = await USER_URL.post(
                `/products/admin/${selectedProduct.id}/`,
                { status },
            );
            console.log('Response:', res.data); // Log success response
            closeModal(); // Close the modal on success
        } catch (error) {
            console.error('Error updating product status:', error);
        } finally {
            setLoading(false); // End loading
        }
    };

    return (
        <div>
            {isModalOpen && selectedProduct && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                    <div className="bg-white p-6 rounded-lg max-w-md w-auto md:w-full shadow-lg">
                        <div className="flex justify-between items-center">
                            <h2 className="text-xl font-semibold mb-4">
                                {selectedProduct.name} - {status === "Approved" ? "Approved" : "Rejected"}
                            </h2>
                            <span
                                className="text-2xl cursor-pointer"
                                onClick={closeModal}
                            >
                                <IoCloseSharp />
                            </span>
                        </div>

                        <p className="line-clamp-2">{selectedProduct.description}</p>
                        <p className="text-lg font-bold mt-2">
                            Price: ${selectedProduct.price}
                        </p>

                        <div className="flex justify-between space-x-4 mt-4">
                            <button
                                className={`px-4 py-2 rounded w-full ease-in duration-200 border-solid border-2 
                                            ${status === "Approved"
                                        ? "bg-transparent text-green-500 border-green-500 hover:text-white hover:bg-green-500"
                                        : "bg-transparent text-red-500 border-red-500 hover:text-white hover:bg-red-500"}`}
                                onClick={handleStatusUpdate}
                                disabled={loading}
                            >
                                {loading ? 'Processing...' : status === "Approved" ? "Approve" : "Reject"}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default ProductApprovalModel;
